import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ConfirmationPage from "./pages/ConfirmationPage";
import FailedPage from "./pages/FailedPage";
import NotValidPage from "./pages/NotValidPage";

/** Main app function. */
const App = (): JSX.Element => (
  <Routes>
    <Route path="/confirmation" element={<ConfirmationPage />} />
    <Route path="/failed" element={<FailedPage />} />
    <Route path="/invalid" element={<NotValidPage />} />
    <Route path="/:id" element={<Home />} />
    <Route path="/" element={<FailedPage />} />
  </Routes>
);

export default App;
